// Häufige Fragen (Startseite / global)
export const faqItems = [
  {
    q: "Was kostet eine Entrümpelung?",
    a: "Die Kosten hängen unter anderem vom Umfang, der Art und Menge der Gegenstände, der Zugänglichkeit des Objekts, dem Personalaufwand, den Transportwegen, den Entsorgungskosten und gewünschten Zusatzleistungen ab. Nach Klärung des Umfangs erhalten Sie ein nachvollziehbares Angebot.",
  },
  {
    q: "Kann ich vorab Bilder senden?",
    a: "Ja. Bilder helfen bei einer ersten Einschätzung. Sie können diese über das Anfrageformular oder nach Kontaktaufnahme per WhatsApp senden. Bei umfangreicheren oder schwer einschätzbaren Projekten kann zusätzlich eine Besichtigung sinnvoll sein.",
  },
  {
    q: "Übernehmen Sie auch einzelne Räume?",
    a: "Ja. Rümpeltaxi unterstützt sowohl bei kompletten Haushaltsauflösungen als auch bei einzelnen Kellern, Dachböden, Garagen, Zimmern oder Teilbereichen.",
  },
  {
    q: "Was bedeutet besenreine Übergabe?",
    a: "Besenrein bedeutet in der Regel, dass die vereinbarten Gegenstände entfernt und die geräumten Flächen grob ausgekehrt übergeben werden. Weitergehende Reinigungsleistungen müssen gesondert vereinbart werden.",
  },
  {
    q: "Was geschieht mit verwertbaren Gegenständen?",
    a: "Ob und wie Gegenstände weiterverwendet, angerechnet, gespendet oder entsorgt werden können, wird abhängig von Zustand, Nachfrage und Vereinbarung individuell geprüft. Eine pauschale Wertanrechnung kann nicht zugesagt werden.",
  },
  {
    q: "Wie schnell kann ein Termin stattfinden?",
    a: "Die Terminverfügbarkeit hängt vom Umfang des Projekts, dem Einsatzort und der aktuellen Auslastung ab. Dringende Anfragen prüfen wir individuell.",
  },
  {
    q: "Räumen Sie auch Gewerbeobjekte?",
    a: "Ja. Wir bearbeiten auch Anfragen für Büros, Praxen, Lagerflächen, Hallen, Werkstätten, Geschäfte und weitere gewerblich genutzte Objekte.",
  },
  {
    q: "In welchen Regionen arbeitet Rümpeltaxi?",
    a: "Zu den regelmäßigen Einsatzregionen gehören unter anderem Ulm, Neu-Ulm, Günzburg, Illertissen, Memmingen, Göppingen, Stuttgart, Ludwigsburg und Heilbronn. Weitere Orte prüfen wir gerne auf Anfrage.",
  },
];
